import type { FaireProductEntity } from "../../entity_types/product";

export const p_t4d5auhbdg: FaireProductEntity = {
  token: "p_t4d5auhbdg",
  type: "product",
  name: "Tropic Sunrise Candle | Pomelo, Coconut, & Orange",
  brandToken: "b_tthhaz7z5x",
  brandName: "Jungle Club",
  imageUrl:
    "https://cdn.faire.com/fastly/b4c37995e62f93b4ae25076aedb53a7ec963f51f3f4e23689adde1af0e7a4f45.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/685332ed595f48b0ff0bd153da61ff1ccb4a99b1904a17fccb0d70ecdaec9b26.jpeg",
    "https://cdn.faire.com/fastly/e48edfb75919a8685eaf13792640e9f89bbaa4062de97fa88228c9ee3bf94df7.jpeg",
    "https://cdn.faire.com/fastly/43b1be72afc06dc00e5750fa38a44baf382b8898cbad4fe7b9f90a57d19cba10.jpeg",
    "https://cdn.faire.com/fastly/1a03f9d9b7900ca30a71957a9eea8a242662001caf7ba6fbb6389f6ce0e7ef0e.jpeg",
    "https://cdn.faire.com/fastly/8c02997ee90a6182e68a9888f7c74eb5ded1b6c62cdb8fe378687433685bb4b3.jpeg",
    "https://cdn.faire.com/fastly/efb3c1cb94223c313b7643ac5d38b601ebed61d4a21852ee3c7f4a83f633f5d1.jpeg",
    "https://cdn.faire.com/fastly/23d7ded7cf365c59178ff05b1e129ef3deb853fa98113a0ab4b8ce4b86553a41.jpeg",
  ],
  priceDollars: 15,
  description:
    "Embrace the essence of paradise with the Tropic Sunrise Candle, elegantly housed in a warm peachy ceramic vessel. Hand-poured in sunny San Diego, this candle features a premium fragrance blended with paraffin-free coconut soy wax for an eco-friendly, clean burn.\n\nWith invigorating notes of pomelo, luscious coconut, and bright orange, it evokes the vibrant spirit of a tropical morning. Its charming design adds a playful touch to any décor.\n\nIgnite the Tropic Sunrise Candle to envelop your space in a refreshing, uplifting scent that energizes your spirit and enhances your mood. Ideal for self-care moments or as a delightful gift, this candle invites you to savor your own slice of paradise.\n\n• Cork Lid\n• Scent | Pomelo, Coconut, & Orange\n• Size | 10 Ounces\n• Ceramic Vessel Imported\n• Designed and Poured in the USA",
  tags: [],
  msrpDollars: 29.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:06.114Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
